export const HIDE_NOTIFICATION = "[notify] Hide notification";
export const SHOW_NOTIFICATION = "[notify] Show notification";

export const hideNotification = () => ({
  type: HIDE_NOTIFICATION,
});

export const showNotification = (
  message = "",
  type = "warning",
  notify = true
) => ({
  type: SHOW_NOTIFICATION,
  payload: { message, type, notify }
});



// WEBPACK FOOTER //
// ./src/redux/actions/notification.js